import { configureStore } from "@reduxjs/toolkit";
import TourSlice from "./TourSlice";
import ClassroomSlice from "./ClassroomSlice";
import LearningSlice from "./LearningSlice";
import UserSlice from "./UserSlice";
import DetailsofProfileSlice from "./DetailsofProfileSlice";
import NotificationsSlice from "./NotificationsSlice";
import ThemeSlice from "./ThemeSlice";

export const store = configureStore({
  reducer: {
    tour: TourSlice,
    classRoom: ClassroomSlice,
    learning: LearningSlice,
    user: UserSlice,
    profileDetails: DetailsofProfileSlice,
    notifications: NotificationsSlice,
    theme: ThemeSlice,
  },
});
